var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.2683 1.82568H9.26831C7.94223 1.82568 6.67046 2.35247 5.73278 3.29015C4.79509 4.22783 4.26831 5.4996 4.26831 6.82568V9.82568H1.26831V13.8257H4.26831V21.8257H8.26831V13.8257H11.2683L12.2683 9.82568H8.26831V6.82568C8.26831 6.56047 8.37367 6.30611 8.5612 6.11858C8.74874 5.93104 9.00309 5.82568 9.26831 5.82568H12.2683V1.82568Z","stroke":"#F4F4F4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Facebook.defaultProps = {"width":"24","height":"23","viewBox":"0 0 14 23","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
